import { FC, ComponentPropsWithoutRef } from 'react';
import classNames from 'classnames';
import { AnchorTarget as _AnchorTarget } from 'jbc-front/components/ScrollSpy/v2';
import styles from './AnchorTarget.scss';

export const AnchorTarget: FC<ComponentPropsWithoutRef<typeof _AnchorTarget>> = ({ className, ...rest }) => {
  return <_AnchorTarget {...rest} className={classNames(styles.headerOffset, className)} />;
};
